import * as React from 'react';

import { SegmentLabel } from '@acceligentllc/storybook';

import styles from './styles.module.scss';

interface Props {
	title?: string;
	tooltip?: string;
}

const FormSection = (props: React.PropsWithChildren<Props>) => {
	const { children, title, tooltip } = props;

	return (
		<div className={styles.form__section}>
			{!!title &&
				<div className="m-l-m m-b-m">
					<SegmentLabel label={title} tooltip={tooltip} tooltipPosition={!!tooltip ? 'right' : undefined} />
				</div>
			}
			{children}
		</div>
	);
};

export default React.memo(FormSection);
